/***
 *
 *   SIGN UP (project invite)
 *   Phase 9 — auth chrome. Keep project invite query params + live API.
 *
 **********/

import React, { useContext } from 'react';
import { Animate, Form, Link } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';
import { useSearchParams } from 'react-router-dom';

export function SignupProject(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    const project = searchParams.get('project') || '';
    const account = searchParams.get('account');
    const projectLabel = project
        ? project.charAt(0).toUpperCase() + project.slice(1)
        : '';

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('user.create.for', { name: projectLabel })}
                description={_t('signup.description')}
                footer={
                    <>
                        {_t('signup.already')} <Link url="/signin" text={_t('signin.label')} />
                    </>
                }>
                <Form
                    data={{
                        first_name: {
                            label: _t('firstName.title'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('firstName.empty'),
                        },
                        last_name: {
                            label: _t('lastName.title'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('lastName.empty'),
                        },
                        email: {
                            label: _t('email.label'),
                            value: email,
                            type: 'email',
                            required: true,
                        },
                        password: {
                            label: _t('password.label'),
                            type: 'password',
                            required: true,
                            complexPassword: true,
                        },
                        confirm_password: {
                            type: 'hidden',
                            value: null,
                        },
                    }}
                    auth={false}
                    url="/api/user/project"
                    method="POST"
                    injectedData={{
                        account_id: account,
                        project_name: project,
                    }}
                    buttonText={_t('user.create.label')}
                    callback={context.signin}
                />
            </AuthPage>
        </Animate>
    );
}
